import { render, staticRenderFns } from "./WhereYouLive.vue?vue&type=template&id=40a35e88"
import script from "./WhereYouLive.vue?vue&type=script&lang=js"
export * from "./WhereYouLive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports